// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"1ca54a13","375":"f66b9556","452":"f13ffd0a","875":"a00f3651","935":"36319834"}[chunkId] + ".chunk.css";
};